jQuery(function($) {
	jQuery(document).ready(function() {
		
		gsap.utils.toArray(".work__item-img").forEach(function(section) {
			var item = section.querySelector("img");
		
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: "top bottom", // the default values
					end: "220% bottom", // end trigger, marker location
					scrub: true,
					markers: false, // testing		
				}
			});
			
			tl.fromTo(item, {
				yPercent: -10,
				ease: "linear",
			}, {
				yPercent: 10,
				ease: "linear",
			});
		
		});
		
	});
});